import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-merque',
  templateUrl: './merque.component.html',
  styleUrls: ['./merque.component.css']
})
export class MerqueComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
